import { Pipe, PipeTransform } from '@angular/core';
import { PercentPipe } from '@angular/common';

import { I18nService } from '@app/core';

/**
 * Localized percent pipe (i18n)
 */
@Pipe({
  name: 'lpercent',
  standalone: false
})
export class LpercentPipe implements PipeTransform {
  constructor(private percentPipe: PercentPipe, private i18nService: I18nService) {}

  transform(value: any, digitsInfo?: string) {
    return this.percentPipe.transform(value, digitsInfo, this.i18nService.language);
  }
}
